import React from "react";
import { Link } from "react-router-dom";
import { PublicNavbar } from "./Landing";
import { Button } from "@/components/ui/button";
import { Check, X, Flame, Rocket, Leaf } from "lucide-react";

const plans = [
  {
    name: "Gratis 30 Hari",
    price: "Rp0",
    cadence: "/30 hari",
    icon: <Flame className="w-5 h-5" />,
    accent: "border-white/10",
    cta: "Mulai Gratis",
    to: "/register",
    testid: "plan-free",
    features: [
      "Semua fitur Agent Pro selama 30 hari",
      "Tidak perlu kartu kredit",
      "Setelah 30 hari otomatis turun ke paket Minimalis",
    ],
  },
  {
    name: "Minimalis",
    price: "Rp20.000",
    cadence: "/bulan",
    icon: <Leaf className="w-5 h-5" />,
    accent: "border-white/10",
    cta: "Pilih Minimalis",
    to: "/register",
    testid: "plan-minimalis",
    features: ["10 listing", "10 lead"],
    excluded: ["Tanpa Co-Broke"],
  },
  {
    name: "Agent Pro",
    price: "Rp99.000",
    cadence: "/bulan",
    promo: "Harga promo s.d. Desember 2026",
    icon: <Rocket className="w-5 h-5" />,
    accent: "border-orange-500/60 shadow-2xl shadow-orange-500/10 scale-[1.02]",
    highlighted: true,
    cta: "Pilih Agent Pro",
    to: "/register",
    testid: "plan-pro",
    features: ["Semua fitur unlimited", "Listing & lead unlimited", "Co-Broke & Radar Peta", "AI copywriting deskripsi listing"],
  },
];

export default function Pricing() {
  return (
    <div className="min-h-screen bg-[#0A0D14] text-slate-100">
      <PublicNavbar />
      <section className="px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <span className="text-xs uppercase tracking-widest text-orange-400 font-semibold">Pricing Sederhana</span>
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mt-3">
              Pilih paket yang <span className="bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">sesuai ritme kerja</span> Anda.
            </h1>
            <p className="mt-5 text-slate-400">
              Coba gratis 30 hari dengan semua fitur. Tanpa kartu kredit.
            </p>
          </div>

          <div className="mt-14 grid md:grid-cols-3 gap-6 items-stretch">
            {plans.map((p) => (
              <div key={p.name} data-testid={p.testid}
                   className={`relative rounded-2xl bg-[#141C2E] border p-7 flex flex-col ${p.accent}`}>
                {p.highlighted && (
                  <div className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-orange-500 text-white text-[11px] font-bold tracking-wider uppercase">
                    Paling Populer
                  </div>
                )}
                <div className="flex items-center gap-2 text-orange-400">
                  {p.icon}
                  <h3 className="text-lg font-semibold text-slate-100">{p.name}</h3>
                </div>
                <div className="mt-4 flex items-baseline gap-1">
                  <span className="text-4xl font-extrabold">{p.price}</span>
                  <span className="text-slate-500 text-sm">{p.cadence}</span>
                </div>
                {p.promo && <div className="mt-2 text-xs font-semibold text-orange-400" data-testid={`${p.testid}-promo`}>{p.promo}</div>}
                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-slate-300">
                      <Check className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" /> {f}
                    </li>
                  ))}
                  {p.excluded?.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-slate-500">
                      <X className="w-4 h-4 text-red-400 shrink-0 mt-0.5" /> {f}
                    </li>
                  ))}
                </ul>
                <Link to={p.to} className="mt-8" data-testid={`${p.testid}-cta`}>
                  <Button className={`w-full py-6 font-semibold ${p.highlighted
                    ? "bg-gradient-to-r from-[#FF5722] to-[#F97316] hover:from-[#F97316] hover:to-[#EA580C]"
                    : "bg-white/5 hover:bg-white/10 border border-white/10"}`}>
                    {p.cta}
                  </Button>
                </Link>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center text-sm text-slate-500">
            Pembayaran dalam IDR · Butuh invoice? Hubungi tim kami lewat email.
          </div>
        </div>
      </section>
    </div>
  );
}
